import {IN_PROGRESS, LAUNCHED, READY_TO_LAUNCH, SAVED_AS_DRAFT, STOPPED, ARCHIVED} from "@irati/insights/constants/schedule"
import {IN_PROGRESS_STATUSES, FAILED, COMPLETE} from "@irati/insights/constants/report"
import {greys} from "@irati/ui/src/global/colors"

import {
  DRAFT_STATUS_COLOR,
  PROGRESS_STATUS_COLOR,
  REPORT_COMPLETE_STATUS_COLOR,
  REPORT_ERROR_STATUS_COLOR,
  REPORT_IN_PROGRESS_STATUS_COLOR,
  NO_MATCH_COLOR
} from "../../ui/colors"

const helper = {}

helper.determineScheduleStatusColor = (status, useDefault = true) => {
  switch (status) {
    case SAVED_AS_DRAFT:
    case READY_TO_LAUNCH:
      return DRAFT_STATUS_COLOR
    case IN_PROGRESS:
    case LAUNCHED:
      return PROGRESS_STATUS_COLOR
    case STOPPED:
    case ARCHIVED:
      return greys.medium
    default:
      if (useDefault) return DRAFT_STATUS_COLOR
  }
}

helper.determineReportStatusColor = (status, useDefault = true) => {
  if (IN_PROGRESS_STATUSES.includes(status)) return REPORT_IN_PROGRESS_STATUS_COLOR

  switch (status) {
    case FAILED:
      return REPORT_ERROR_STATUS_COLOR
    case COMPLETE:
      return REPORT_COMPLETE_STATUS_COLOR
    default:
      if (useDefault) return REPORT_IN_PROGRESS_STATUS_COLOR
  }
}

helper.determineStatusColor = (status) => {
  let colors = [determineScheduleStatusColor(status, false), determineReportStatusColor(status, false)]
  colors = colors.filter((c) => c)
  return colors[0] || NO_MATCH_COLOR
}

export const determineScheduleStatusColor = helper.determineScheduleStatusColor
export const determineReportStatusColor = helper.determineReportStatusColor
export const determineStatusColor = helper.determineStatusColor

export default helper
